module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"All loan notices"},"et":{"title":"All loan notices"},"ru":{"title":"All loan notices"}}')
  delete Component.options._Ctor
}
